


/**
 * 安全获取对象字段
 * @category 工具
 */
export const get = (obj: any, path: string, defat?: any) => {
  if (obj == null) return defat;
  const keys = JSON.stringify(path).match(/[^.,\s[\]'"]+/g);
  if (!keys) return defat;
  let ret;
  for (let i = 0, j = keys.length; i < j; i++) {
    ret = obj[keys[i]];
    if (ret == null) return defat;
    obj = ret;
  }
  return ret;
};

/**
 * 安全设置对象字段
 * @category 工具
 * @param {Object} obj 目标对象
 * @param {String} path 字段路径，支持 'a.b[0].c[d]'、'[a][b][c]'、'[a,b,c]'、'[a,b,c]'
 * @param {*} value 设置的值
 */
export const set = (obj: any, path: string, value: any) => {
  if (obj == null || path == null) return obj;
  const keys = JSON.stringify(path).match(/[^.,\s[\]'"]+/g);
  if (!keys) return obj;
  let _obj = obj;
  for (let i = 0, j = keys.length; i < j; i++) {
    const temp = _obj[keys[i]];
    if (temp == null) {
      if (i + 1 === j) {
        _obj[keys[i]] = value;
        break;
      }
      _obj[keys[i]] = /\d+/.test(keys[i]) ? [] : {};
    } else if (i + 1 === j) {
      _obj[keys[i]] = value;
    }
    _obj = _obj[keys[i]];
  }
  return obj;
};

export function getCookie(cname: string, cookie = ""): string {
  if (!cookie && typeof window !== "undefined") cookie = document.cookie;
  if (!cookie) return "";
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function setCookie(cname: string, cvalue: string, exdays?: number) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays || 0) * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}


export function mergeDeep(target: Record<string, any>, source: Record<string, any>): Record<string, any> {
  Object.keys(source).forEach(key => {
    if (source[key] instanceof Object && key in target) {
      source[key] = { ...source[key], ...mergeDeep(target[key], source[key]) };
    }
  });
  return { ...(target || {}), ...source };
}



export function generateRandomID(length = 16) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters[randomIndex];
  }

  return result;
}


export const isEmpty = (val: any) =>
  val == null || !(Object.keys(val) || val).length;


export const promisify = (fn: (...args: any) => any) => {
  return function (...args: any[]) {
    return new Promise((resolve, _reject) => {
      fn(...args, (data: any) => {
        resolve(data);
      });
    });
  };
}




/**
 * 保留指定位数的小数
 * @param num 原数据
 * @param decimal 小数位数
 * @returns {number} 格式化后的数字，或原始输入
 */
export const formatDecimal = (num: number, decimal: number) => {
  if (!isFinite(num) || isNaN(num)) {
    return num; // 对于 NaN 和 Infinity 直接返回原始数值
  }
  if (!Number.isInteger(decimal) || decimal < 0) {
    return num; // 如果小数位数无效，返回原始数值
  }

  return parseFloat(num.toFixed(decimal));
}


export function isIPAddress(hostname) {
  // 正则表达式用于匹配 IPv4 地址
  const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  // 正则表达式用于匹配 IPv6 地址
  const ipv6Pattern = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;

  return ipv4Pattern.test(hostname) || ipv6Pattern.test(hostname);
}